import React from 'react';
import useTitle from 'react-use/lib/useTitle';
import { useLocation } from 'react-router-dom';
import { PageLoader } from 'app/modules/common/page-loader';
import { DetailFragmentRoutes } from 'app/modules/detail-module/routes';
import { DetailModuleLayoutModel } from 'app/modules/detail-module/data';
import { ModuleHeaderFragment } from 'app/fragments/module-header-fragment';
import HEAD from 'app/components/SeoHelmet';

export const DetailModuleLayout = (props: DetailModuleLayoutModel) => {
  useTitle(`AIDA - ${props.pageTitle}`);

  const location = useLocation();
  const showSwitch =
    location.pathname.indexOf('publishers') > -1 ||
    location.pathname.indexOf('projects') > -1 ||
    location.pathname.indexOf('donors') > -1 ||
    location.pathname.indexOf('sectors') > -1 ||
    location.pathname.indexOf('organisations') > -1;

  let currentPath = '';

  if (location.pathname.indexOf('publishers') > -1) {
    currentPath = 'publishers';
  } else if (location.pathname.indexOf('projects') > -1) {
    currentPath = 'projects';
  } else if (location.pathname.indexOf('donors') > -1) {
    currentPath = 'donors';
  } else if (location.pathname.indexOf('sectors') > -1) {
    currentPath = 'sectors';
  } else if (location.pathname.indexOf('organisations') > -1) {
    currentPath = 'organisations';
  } else {
    currentPath = 'none';
  }

  const description = {
    publishers: `See all Detailed Development aid activities and finance information for ${props.param} publisher`,
    projects: `See all Detailed Development aid activities and finance information for ${props.param} project`,
    donors: `See all Detailed Development aid activities and finance information for ${props.param} donor`,
    sectors: `See all Detailed Development aid activities and finance information for ${props.param} sector`,
    organisations: `See all Detailed Development aid activities and finance information for ${props.param} organisation`,
    none: '',
  }[currentPath] as string;

  const title = {
    publishers: `${props.param} publisher overview for Development aid activities and finance information`,
    projects: `${props.param} project overview for Development aid activities and finance information`,
    donors: `${props.param} donor overview for Development aid activities and finance information`,
    sectors: `${props.param} sector overview for Development aid activities and finance information`,
    organisations: `${props.param} organisation's overview for Development aid activities and finance information`,
    none: '',
  }[currentPath] as string;

  return (
    <React.Fragment>
      <HEAD
        description={description}
        title={title}
        name="AIDA"
        type="website"
      />
      {props.loading && <PageLoader />}
      <ModuleHeaderFragment
        switch
        showBreadCrumbs
        showFilter
        showAggregate={showSwitch}
        breadcrumbs={props.breadcrumbs}
        switchProps={{
          itemOne: { label: 'Viz' },
          itemTwo: { label: 'Table' },
        }}
      />
      <DetailFragmentRoutes
        param={props.param}
        subText={props.subText}
        wikiLink={props.wikiLink}
        statData={props.statData}
        pageTitle={props.pageTitle}
        detailBaseFilter={props.detailBaseFilter}
        lineData={props.lineData}
        type={props.type}
      />
    </React.Fragment>
  );
};
